var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSidePanel = function SvgTextSidePanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.033 16.5v-.602l1.624-.294-.224.308v-8.54l.252.21H8.983l.28-.238-.28 1.778h-.7V6.728h7.434v2.394h-.7l-.28-1.75.28.21h-2.702l.252-.21v8.54l-.21-.308 1.61.294v.602z"
  })));
};
export default SvgTextSidePanel;